<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoInserir">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoInserir">
			<form (keypress)="ocultarMensagem()" #f="ngForm" name="form" novalidate>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>

						<div class="field col-12 md:col-4">
							<label htmlFor="nomeFornecedor">Nome Fornecedor</label>
							<input oninput="this.value = this.value.toUpperCase();" pInputText type="text"
								name="nomeFornecedor" ngModel #nomeFornecedor="ngModel"
								[(ngModel)]="fornecedor.nomeFornecedor" required />
							<div *ngIf="nomeFornecedor.hasError('required') && nomeFornecedor.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>

						<div class="field col-12 md:col-5">
							<label htmlFor="razaoSocial">Razão Social</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="razaoSocial" ngModel [(ngModel)]="fornecedor.razaoSocial"
								#razaoSocial="ngModel" />
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="cnpj">CNPJ</label>
							<p-inputMask mask="99.999.999/9999-99" [unmask]="true" type="text"
								placeholder="00.000.000/0000-00" name="cnpj" ngModel #cnpj="ngModel"
								[(ngModel)]="fornecedor.cnpj">
							</p-inputMask>
						</div>
						<div class="field col-12 md:col-4">
							<label htmlFor="nomeContato">Nome contato</label>
							<input oninput="this.value = this.value.toUpperCase();" pInputText type="text"
								name="nomeContato" ngModel #nomeContato="ngModel"
								[(ngModel)]="fornecedor.nomeContato" />
						</div>

						<div class="field col-12 md:col-3">
							<label htmlFor="foneContato">Fone contato</label>
							<p-inputMask mask="(99)99999-9999" placeholder="(99)99999-9999" name="foneContato"
								[(ngModel)]="fornecedor.foneContato"></p-inputMask>
						</div>

						<div class="field col-12 md:col-2">
							<label htmlFor="cidade">UF</label>
							<p-dropdown [options]="listaUfs" optionLabel="siglaUf" [editable]="true" [filter]="true"
								emptyFilterMessage="Nenhum registro" (onChange)="listarMunicipios()" placeholder="UF"
								name="uf" ngModel #uf="ngModel" [(ngModel)]="ufSelecionado">
							</p-dropdown>
						</div>

						<div class="field col-12 md:col-3">
							<label htmlFor="cidade">Cidade</label>
							<p-dropdown [options]="listaMunicipios" [disabled]="!isUfSelecionada"
								optionLabel="descricao" [editable]="true" [filter]="true"
								emptyFilterMessage="Nenhum registro" placeholder="Selecione a Cidade" name="cidade"
								ngModel #cidade="ngModel" [(ngModel)]="municipioSelecionado" [required]="true"
								(onChange)="selecionaCidade()">
							</p-dropdown>
							<div *ngIf="enderecoRequerido" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>


					</div>
					<div class="p-fluid p-formgrid grid justify-content-between">
						<div class="col-12 md:col-4">
							<button *ngIf="!progressoRequisicao else exibirBotaoFalso"
								type="button" pButton icon="pi pi-check" label="Salvar"
								class="p-button-outlined p-button-success md:w-9rem"
								[disabled]="!f.valid || enderecoRequerido " (click)="salvarFornecedor()">
							</button>
							<ng-template #exibirBotaoFalso>
								<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Salvar"
								class="p-button-outlined p-button-success md:w-9rem" disabled></button>
							</ng-template>
						</div>
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/fornecedor"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>